import React from 'react';
import classnames from 'classnames';
import Edit from '@mui/icons-material/Edit';

import { Button } from 'uikit/buttons';
import { Header } from 'uikit/layouts';
import { Markdown, Typo } from 'uikit/content';

import styles from '../styles/initiativeWizardSummaryCard.module.scss';

const InitiativeWizardSummaryCard = ({
  title,
  error,
  body = '',
  hasMarkdown,
  onEditButtonClick,
}) => (
  <div
    className={classnames(styles.element, {
      [styles.hasError]: error,
      [styles.isFullWidth]: hasMarkdown,
    })}
  >
    <div className={styles.inner}>
      <Header
        className={styles.header}
        leftColumn={(
          <Typo
            className={styles.title}
            element="h6"
            variant="s01"
            weight="medium"
          >
            {title}
          </Typo>
        )}
        rightColumn={(
          <Typo
            className={styles.error}
            element="span"
            variant="s01"
            weight="medium"
          >
            {error}
          </Typo>
        )}
      />
      <div className={styles.body}>
        {hasMarkdown ? (
          <Markdown className={styles.content} content={body} shouldEscapeHtml />
        ) : (
          <div className={styles.content}>
            <Typo className={styles.text}>{body}</Typo>
          </div>
        )}
        <Button
          className={styles.button}
          icon={<Edit />}
          onClick={onEditButtonClick}
          size="small"
          variant="ghost"
        />
      </div>
    </div>
  </div>
);

export default React.memo(InitiativeWizardSummaryCard);
